import { render, staticRenderFns } from "./ColorFilter.vue?vue&type=template&id=bb7095aa&scoped=true&"
import script from "./ColorFilter.vue?vue&type=script&lang=js&"
export * from "./ColorFilter.vue?vue&type=script&lang=js&"
import style0 from "./ColorFilter.vue?vue&type=style&index=0&id=bb7095aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7095aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VChip,VListItem,VListItemAction,VSelect})
